import React, { useEffect, useMemo } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import MicRoundedIcon from '@mui/icons-material/MicRounded';

const VoiceAttachmentPreview = ({ audioBlob, fileName = 'Voice note', onRemove }) => {
  const audioUrl = useMemo(() => audioBlob ? URL.createObjectURL(audioBlob) : '', [audioBlob]);
  useEffect(() => () => audioUrl && URL.revokeObjectURL(audioUrl), [audioUrl]);
  if (!audioBlob) return null;

  return (
    <Box sx={{ mt: 1, p: 1, border: '1px solid #dce5df', borderRadius: '16px', bgcolor: '#f7fbf8' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.65 }}>
        <MicRoundedIcon sx={{ color: '#3f7f6b' }} />
        <Typography sx={{ flex: 1, minWidth: 0, fontSize: '0.82rem', fontWeight: 700, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{fileName}</Typography>
        <IconButton size="small" onClick={onRemove} aria-label="Remove voice note"><CloseRoundedIcon fontSize="small" /></IconButton>
      </Box>
      <Box component="audio" controls src={audioUrl} sx={{ width: '100%', display: 'block' }} />
    </Box>
  );
};

export default VoiceAttachmentPreview;
